import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { eachDayOfInterval, getWeekOfMonth, parse } from 'date-fns-v2';
import { format } from 'date-fns-v1';
import qDocPromise from '../js/qDoc';

const styles = require('./Calendar-styles.css');

const Calendar = ({ data }) => {
  const [qDoc, setQDoc] = useState(null);
  const [qObj, setQObj] = useState(null);
  const handleDayClick = useCallback((event) => {
    if (qObj && event.target.dataset.qElemNo) {
      const qElemNo = Number(event.target.dataset.qElemNo);
      qObj.selectListObjectValues('/qListObjectDef', [qElemNo], true);
    }
  }, [data, qObj]);
  useEffect(() => {
    (async () => {
      try {
        const _qDoc = await qDocPromise;
        setQDoc(_qDoc);
        const _qObj = await _qDoc.createSessionObject({
          qInfo: { qType: 'data' },
          qListObjectDef: {
            qDef: { qFieldDefs: ["=If(d_DateYear = '$(vYear)', Date(Floor(d_Date), 'YYYY-MM-DD'))"] },
          },
        });
        setQObj(_qObj);
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    })();
  }, []);
  useEffect(() => () => {
    if (qObj) qDoc.destroySessionObject(qObj.id);
  }, [qObj]);
  const calendar = useMemo(() => (
    data ? eachDayOfInterval({
      start: parse(data[0].qNodes[0].qAttrDims.qValues[0].qText, 'yyyy-MM-dd', new Date()),
      end: parse(data[0].qNodes[data[0].qNodes.length - 1].qAttrDims.qValues[0].qText, 'yyyy-MM-dd', new Date()),
    }).reduce((_calendar, date) => {
      const monthName = format(date, 'MMM');
      const weekName = String(getWeekOfMonth(date));
      const dayName = format(date, 'dd');
      const d = data[0].qNodes.find((qNode) => qNode.qAttrDims.qValues[0].qText === format(date, 'YYYY-MM-DD')) || { qNodes: [], qElemNo: null };
      _calendar[monthName] = _calendar[monthName] || {}; // eslint-disable-line no-param-reassign
      _calendar[monthName][weekName] = _calendar[monthName][weekName] || {}; // eslint-disable-line no-param-reassign
      _calendar[monthName][weekName][dayName] = { // eslint-disable-line no-param-reassign
        date,
        dayOfMonth: format(date, 'D'),
        numOfGames: d.qNodes.length,
        qElemNo: d.qElemNo,
      };
      return _calendar;
    }, {}) : null
  ), [data]);
  const maxNumGamesInADay = useMemo(() => (
    data ? Math.max(...data[0].qNodes.map((gameday) => gameday.qNodes.length)) : null
  ), [data]);
  return (
    <div className={styles.calendar}>
      <div className={styles.heading}>TOURNAMENT</div>
      {calendar && Object.entries(calendar).map(([monthName, month]) => (
        <div key={monthName} className={styles.month}>
          <div className={styles.monthName}>{monthName}</div>
          <div className={styles.weekdays}>
            <div className={classnames(styles.weekday, styles.Su)}>S</div>
            <div className={classnames(styles.weekday, styles.Mo)}>M</div>
            <div className={classnames(styles.weekday, styles.Tu)}>T</div>
            <div className={classnames(styles.weekday, styles.We)}>W</div>
            <div className={classnames(styles.weekday, styles.Th)}>T</div>
            <div className={classnames(styles.weekday, styles.Fr)}>F</div>
            <div className={classnames(styles.weekday, styles.Sa)}>S</div>
          </div>
          {Object.entries(month).map(([weekName, week]) => (
            <div key={weekName} className={styles.week}>
              {Object.entries(week).map(([dayName, day]) => (
                <div
                  key={dayName}
                  data-q-elem-no={day.qElemNo}
                  className={classnames(styles.day, styles[dayName])}
                  style={{ backgroundColor: `rgba(34, 144, 191, ${day.numOfGames / maxNumGamesInADay})` }}
                  onClick={handleDayClick}
                >
                  {day.dayOfMonth}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

Calendar.propTypes = {
  data: PropTypes.array,
};
Calendar.defaultProps = {
  data: null,
};

export default Calendar;
